import { TableParams } from '../models/TableParams'

export const initialQuery: TableParams = {
  pagination: { current: 1, pageSize: 20 },
}
